<template>
    <b-card
        class="shadow-sm mb-3"
        header-class="px-3"
        body-class="px-3"
        >
        <template v-slot:header>
            <div class="d-flex justify-content-between align-items-center">
                <div>
                    <b-badge variant="basic" class="mr-1">{{ sub.sub_code }}</b-badge>
                    <b-badge variant="advance">{{ sub.sub_type }}</b-badge>
                </div>

                <div>
                    <b-btn class="mr-2"
                        size="sm"
                        variant="dark-border"
                        @click="makeNextVersion(sub)"
                        >
                        다음버전생성
                    </b-btn>
                    <b-btn class=""
                        size="sm"
                        variant="dark-border"
                        :disabled="is_adding"
                        @click="addToQuestion(sub)"
                        >
                        <b-spinner v-show="is_adding" small class="mr-1" />
                        질문에 추가
                    </b-btn>
                </div>
            </div>
        </template>

        <div id="subdescription">{{ sub.sub_description }}</div>       
    </b-card>
</template>

<script>
import { mapState } from 'vuex'
import { getErrorMessage } from '@core/utils/api/errorMessage';

export default {
    name: 'EditingSearchSubComponent',
    props: {
        sub: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            is_adding: false
        }
    },
    computed: {
        ...mapState(['question_subs']),
        question_code(){
            return this.$route.query.question_id
        },
    },
    methods: {
        async addToQuestion (sub) {
            if (this.is_adding) return
            // 트리 저장 직후 등으로 store 의 선택 질문이 비어 있으면 빈 질문 코드로 저장될 수 있다
            if (!this.question_code || this.$store.state.question_composition.question_code !== this.question_code) {
                return this.$EventBus.$emit('toast-warning', '질문 확인 필요', '선택한 질문 정보가 아직 불러와지지 않았습니다. 잠시 후 다시 시도해주세요.')
            }
            const x = {
                sub_code: sub.sub_code,
                sub_name: sub.sub_name,
                sub_type: sub.sub_type,
                sub_condition: sub.sub_condition,
                sub_description: sub.sub_description,
                sub_info: sub.sub_info,
                sub_data_header: sub.sub_data_header,
                sub_data_contents: sub.sub_data_contents,
                sub_priority: sub.sub_priority,
                sub_parent: sub.sub_parent,
                sub_child: sub.sub_child,
                question_code: this.question_code,
                tags: sub.tags,
                label: sub.label
            }
            try {
                this.is_adding = true
                await this.$store.dispatch('saveQuestionSub', x)
                await this.$store.dispatch('saveQuestionComposition')
                this.$EventBus.$emit('toast-success','성공','질문 내용 변경사항을 저장하였습니다.')
            } catch (error) {
                this.$EventBus.$emit('toast-failure', '질문에 추가 실패', getErrorMessage(error, error && error.message ? error.message : '문항을 추가하지 못했습니다.'))
            } finally {
                this.is_adding = false
            }
        },
        async makeNextVersion (sub) {
            try {
                const formData = new FormData()
                formData.append('sub_code', sub.sub_code)

                const response = await this.$axios.post('/subs/versioning', formData)
                let result = response.data
                
                if (result.code === 'success') {
                    //성공일 경우, 다시 검색 쿼리 읽으라는 event를 상위로 발생시킴
                    this.$EventBus.$emit('toast-success', '성공', result.msg)
                    this.$emit('make-next-version-success', result.sub_code)
                } else if (result.code === 'not_found_error') {
                    // this.$emit('toast-success-failure', '실패', '해당 질문이 존재하지 않습니다.')
                    this.$EventBus.$emit('toast-failure', '실패', '해당 질문이 존재하지 않습니다.')
                } else if (result.code === 'duplicateerror') {
                    this.$EventBus.$emit('toast-failure', '실패', result.msg)
                }
            } catch (error) {
                console.log(error);
                this.$EventBus.$emit('toast-failure', '다음버전생성 실패', getErrorMessage(error, '다음 버전을 만들지 못했습니다.'))
            }
        }          
    }
}
</script>

<style>
</style>
